// generated by genversion
export const version = '2.5.2';
//# sourceMappingURL=version.js.map